<p-datepicker
  #pCalendarComponent
  class="pm-calendar"
  [inline]="inline"
  [showWeek]="showWeek"
  [view]="view"
  (onClickOutside)="outsideClicked()"
  (onSelect)="onSelect($event)"
  [(ngModel)]="date"
  [showClear]="showClear"
  [formControl]="ctrl"
  [placeholder]="placeholder"
  dateFormat="dd.mm.yy"
  [selectionMode]="selectionMode"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [disabledDates]="disabledDates"
  (onMonthChange)="onMonthChange($event)"
  [readonlyInput]="true"
/>
